import { render, staticRenderFns } from "./VerifyPassword.vue?vue&type=template&id=60559af9"
import script from "./VerifyPassword.vue?vue&type=script&lang=js"
export * from "./VerifyPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports